import { useEffect, useRef, useState } from "react";
import React from "react";
import "./style.scss";
import copy from "./img/copy.png";
import intro from "./img/promo-image.png";
import introm from "./img/promo-image-m.png";
import { useWindowSize } from "@app/Helpers";
import Button from "@components/Button";
import { getSubscriptionActivationList } from "@api/activation";
import { useQuery } from "@tanstack/react-query";

export default function SubscriptionHead({ hasSubscription }) {
  const { width } = useWindowSize();
  const XGA = width >= 1020;

  const { data } = useQuery({
    queryKey: ["activation-list"],
    queryFn: getSubscriptionActivationList,
  });

  console.log("activation list", data);

  return (
    <div
      className={`subscription-head ${hasSubscription ? "has-subscription" : ""}`}
    >
      <div className="sub-head-copy-wrapper">
        {hasSubscription ? (
          <div className="sub-head-copy-activity">
            <h3 className="sub-head-title">Deine Meinung</h3>
            <p className="sub-head-copy-text">Dein Feedback ist uns wichtig!</p>
            <p className="sub-head-copy-text">
              Hilf uns, das<strong> PremiumAbo </strong> weiter zu verbessern
              und<strong>  sicher dir 20 Punkte </strong> für dein Feedback.
            </p>
            <Button
              disabled={
                data.activations[0].completed ||
                !data.activations[0].subscriptionAvailability
              }
              btnClass="ultra-insider"
              href={`/activities/${data.activations[0].ident}`}
            >
              Verfügbar ab dem 1. April
            </Button>
          </div>
        ) : (
          <img className="sub-head-copy" alt="copy" src={copy} />
        )}
      </div>
      <div className="sub-head-intro">
        <img className="intro" alt="intro" src={XGA ? intro : introm} />
      </div>
    </div>
  );
}
